<template>
  <div v-if="showType === 'loading'">
    <DDLoading />
  </div>
  <div v-else-if="showType === 'normalOld'">
    <div style="background:white">
      <DDMainpic :skuImg="traceInfo.skuImg" :showType="showType" />
      <div class="main-body">
        <div class="skuinfo-box">
          <DDSkuInfo
            :skuName="traceInfo.skuName"
            :vendorName="traceInfo.vendorName"
            :storageDesc="traceInfo.storageDesc"
            :manufactureDate="traceInfo.manufactureDate"
            :productionLabels="traceInfo.productionLabels"
            :showNewDate="traceInfo.showNewDate"
            :originName="traceInfo.originName"
          />
        </div>
        <div class="quality-box">
          <DDQuality
            :taste="traceInfo.taste"
            :tasteDesc="traceInfo.tasteDesc"
            :brix="traceInfo.brix"
          />
        </div>
        <div class="license-box">
          <DDLicense
            :vendorImg="traceInfo.vendorImg"
            :animalQuarantineUrls="traceInfo.animalQuarantineUrls"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="showType === 'normalNew'">
    <trace-info-new :traceInfo="traceInfo"></trace-info-new>
  </div>
  <div v-else>
    <DDLost :errorType="showType" :errorDesc="errorDesc" />
  </div>
</template>

<script>
import DDMainpic from "@/components/Mainpic.vue";
import DDSkuInfo from "@/components/SkuInfo.vue";
import DDQuality from "@/components/Quality.vue";
import DDLicense from "@/components/License.vue";
import DDLoading from "@/components/Loading.vue";

import TraceInfoNew from "@/components/traceInfoNew/index.vue";

import DDLost from "@/views/Lost.vue";
import http from "@/utils/request.js";
import ModuleServiceUrl from "@/utils/moduleServiceUrl";
import { isProduction } from "@/../env";
export default {
  data() {
    return {
      traceInfo: {},
      showType: "loading", // loading, normal，301，404
      errorDesc: "当前商品无溯源信息"
    };
  },
  components: {
    DDMainpic,
    DDSkuInfo,
    DDQuality,
    DDLicense,
    DDLoading,
    DDLost,
    TraceInfoNew
  },
  async created() {
    await ModuleServiceUrl.judgeCtsServiceUrl();
    const isJump = await this.switchIsJumpUrl();
    if (isJump) {
      // 以后不维护这个页面了，直接硬编码写死跳转到电商组页面
      const hash = location.hash;
      const { taskId, barcode } = this.formatLocationHash(hash);

      const shopProtocolAndHost = isProduction
        ? "https://activity.m.ddxq.mobi"
        : "https://activity.m.t.dingdongxiaoqu.com";
      const traceUrl =
        shopProtocolAndHost +
        `/#/productTrackInfoNew?traceSource=1&task_id=${taskId}&barcode=${barcode}`;
      location.replace(traceUrl);
    } else {
      this.getTraceData();
    }
  },
  methods: {
    async getTraceData() {
      // http://localhost:8080/#/?task_id=3290&barcode=092527394021221071405
      const hash = location.hash;
      let { taskId, barcode } = this.formatLocationHash(hash);
      taskId = this.removeHtmlChar(taskId);
      barcode = this.removeHtmlChar(barcode);
      const params = { taskId, barcode };
      const url2 = `${ModuleServiceUrl.getCtsUrl()}/api/v1/commodityTrace/queryV2`; //恢复
      // const url2 = `https://yapi.corp.100.me/mock/2665/api/v1/commodityTrace/queryV2`;
      const result = await http.post(`${url2}`, params);
      const { code, data = {}, success } = result;
      if (success) {
        if (data.newTag) {
          this.traceInfo = data.traceNewV2;
          this.showType = "normalNew";
        } else {
          this.traceInfo = data.traceOld;
          this.showType = "normalOld";
        }
        if (!this.traceInfo || this.traceInfo.length <= 0) {
          this.showType = "none-info";
        }
        return;
      }
      if (code === "11210007") {
        this.showType = "outdate";
        return;
      }
      this.showType = "error";
    },
    formatLocationHash(url) {
      url = url.slice(3);
      const arrParam = url.split("&");
      let taskId = "";
      let barcode = "";
      arrParam.forEach(param => {
        const arr = param.split("=");
        if (arr.length > 1) {
          if (arr[0] === "taskid" || arr[0] === "task_id") {
            taskId = arr[1];
          }
          if (arr[0] === "barcode") {
            barcode = arr[1];
          }
        }
      });
      return {
        taskId,
        barcode
      };
    },
    // 去除html转义符号 %09tab %20space
    removeHtmlChar(str) {
      str = str.replace(/%09/g, "");
      str = str.replace(/%20/g, "");
      return str;
    },

    // 是否跳入电商页面
    async switchIsJumpUrl() {
      const url = `${ModuleServiceUrl.getCtsUrl()}/api/v1/commodityTrace/querySwitch`; //恢复
      try {
        const result = await http.get(`${url}`);
        return result.success && (result.datas || result.data);
      } catch (error) {
        return true;
      }
    }
  }
};
</script>

<style lang="less">
.main-body {
  padding: 0 10px;
}
.skuinfo-box {
  margin-bottom: 15px;
  padding: 0 10px;
}
.quality-box {
  margin-bottom: 25px;
}
</style>
